import React from 'react'
import ReactDOM from 'react-dom/client'
import './utils/translate'
import "rsuite/dist/rsuite.min.css"
import App from './App'
// import StoreProvider from './components/StoreProvider'
import ConnectionProvider from './components/ConnectionProvider'

ReactDOM.createRoot(document.getElementById('main') as HTMLElement).render(
  <React.StrictMode>
    <ConnectionProvider>
      {/* <StoreProvider> */}
      <App />
      {/* </StoreProvider> */}
    </ConnectionProvider>
  </React.StrictMode>,
)
